/**
 * @file baseHash.js
 * @description 코드 기본 문구의 변경 감지용 지문을 계산합니다.
 * @used-in B2 관리자 저장 및 원본 변경 비교
 */
import { getContentEntry } from './registry';

// [비즈니스] 저장 당시 코드 기본값과 현재 기본값을 비교하는 지문이며 보안 용도가 아닙니다.
// [기술] 비동기 API나 의존성 없이 FNV-1a 32비트를 동기로 계산합니다.
// [기술] UTF-8 표준 변형과 달리 UTF-16 코드유닛의 하위·상위 바이트를 순서대로 넣습니다.
const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

// [기능] 문자열을 소문자 16진수 8자리 지문으로 변환하며 비문자열은 빈 문자열로 취급합니다.
export function hashText(text) {
  const source = typeof text === 'string' ? text : '';
  let hash = FNV_OFFSET_BASIS >>> 0;
  for (let i = 0; i < source.length; i += 1) {
    const code = source.charCodeAt(i);
    // [기술] 두 바이트 모두 반영하고 정수 곱셈과 부호 없는 변환으로 하위 비트를 보존합니다.
    hash = Math.imul(hash ^ (code & 0xff), FNV_PRIME) >>> 0;
    hash = Math.imul(hash ^ ((code >>> 8) & 0xff), FNV_PRIME) >>> 0;
  }
  return hash.toString(16).padStart(8, '0');
}

// [기능] 등록 키의 코드 기본값 지문을 반환하고 미등록 키에는 null을 반환합니다.
// [비즈니스] 비교할 원본이 없는 키를 기본값이 빈 문자열인 키와 구분합니다.
export function getBaseHash(key) {
  const entry = getContentEntry(key);
  if (!entry) return null;
  // [비즈니스] 목록은 구성 전체가 편집 단위이므로 지문도 목록 전체로 계산합니다.
  // [기술] JSON.stringify로 항목 순서와 구분자를 결정적으로 표현합니다.
  if (entry.type === 'list') return hashText(JSON.stringify(entry.defaultItems));
  return hashText(entry.defaultText);
}
